<section
  class="recommended-products"
  *ngIf="products.length > 0 || loading"
  [class.recommended-products--animating]="animating"
  [@.disabled]="false"
>
  <header class="recommended-products__header">
    <h3 class="recommended-products__title">{{ titleKey | t }}</h3>
    <p class="recommended-products__subtitle" *ngIf="subtitleKey">{{ subtitleKey | t }}</p>
  </header>

  <div class="recommended-products__body" *ngIf="products.length > 0; else loadingTpl">
    <app-product-rail
      [products]="products"
      [autoScroll]="true"
      [ariaLabel]="titleKey | t"
      (addToCart)="addToCart.emit($event)"
      (buyNow)="buyNow.emit($event)"
      (quickPreview)="quickPreview.emit($event)"
    />
  </div>

  <ng-template #loadingTpl>
    <div class="recommended-products__skeleton" *ngIf="loading" aria-hidden="true">
      <div class="recommended-products__skel-card" *ngFor="let _ of [1, 2, 3, 4]"></div>
    </div>
  </ng-template>
</section>
